import { render, staticRenderFns } from "./cargando.vue?vue&type=template&id=6b297cef&scoped=true&"
import script from "./cargando.vue?vue&type=script&lang=js&"
export * from "./cargando.vue?vue&type=script&lang=js&"
import style0 from "./cargando.vue?vue&type=style&index=0&id=6b297cef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b297cef",
  null
  
)

export default component.exports